import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DownloadSubmissions.css";
import { Slidar } from '../AdminDashbord/Slidar';

const DownloadSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState({
    email: "",
    phone: "",
    courseName: ""
  });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const res = await axios.get("/api/course-downloads");
        if (Array.isArray(res.data)) {
          setSubmissions(res.data);
          setFiltered(res.data);
        } else {
          setError("Invalid data format from server.");
        }
      } catch (err) {
        console.error("Error fetching submissions:", err);
        setError("Failed to fetch submissions.");
      } finally {
        setLoading(false);
      }
    };
    fetchSubmissions();
  }, []);

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    const updatedSearch = { ...search, [name]: value.toLowerCase() };
    setSearch(updatedSearch);

    const filteredResults = submissions.filter((entry) =>
      entry.email.toLowerCase().includes(updatedSearch.email) &&
      entry.phone.toLowerCase().includes(updatedSearch.phone) &&
      entry.courseName.toLowerCase().includes(updatedSearch.courseName)
    );

    setFiltered(filteredResults);
    setCurrentPage(1); // Reset to first page on search
  };

  return (
    <div className="submissions-layout">
      
  <div className="">
  <Slidar />
</div>

      
      <div className="main-content">
       
        <h2>Course Download Submissions</h2>

        <div className="search-filters">
          <input
            type="text"
            name="courseName"
            placeholder="Search by Course"
            value={search.courseName}
            onChange={handleSearchChange}
          />
          <input
            type="text"
            name="phone"
            placeholder="Search by Phone"
            value={search.phone}
            onChange={handleSearchChange}
          />
          <input
            type="text"
            name="email"
            placeholder="Search by Email"
            value={search.email}
            onChange={handleSearchChange}
          />
        </div>

        {loading ? (
          <p>Loading submissions...</p>
        ) : error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : filtered.length === 0 ? (
          <p>No matching submissions found.</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="submissions-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Education</th>
                    <th>Description</th>
                    <th>Course</th>
                    <th>Submitted At</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((entry) => (
                      <tr key={entry._id}>
                        <td>{entry.name}</td>
                        <td>{entry.email}</td>
                        <td>{entry.phone}</td>
                        <td>{entry.education}</td>
                        <td>{entry.description || "N/A"}</td>
                        <td>{entry.courseName}</td>
                        <td>{new Date(entry.createdAt).toLocaleString()}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="pagination-controls" style={{ marginTop: '16px', textAlign: 'center' }}>
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{ marginRight: 8 }}
              >
                Previous
              </button>
              <span style={{ margin: '0 8px' }}>
                Page {currentPage} of {Math.max(1, Math.ceil(filtered.length / itemsPerPage))}
              </span>
              <button
                onClick={() => setCurrentPage((p) => Math.min(Math.ceil(filtered.length / itemsPerPage), p + 1))}
                disabled={currentPage === Math.ceil(filtered.length / itemsPerPage) || filtered.length === 0}
                style={{ marginLeft: 8 }}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    
    
</div>
  );
};

export default DownloadSubmissions;